import { useEffect, useRef, useState } from "react";

import GuestImg from "../../assets/images/conversations/ep-46-akshay-singhal-guest.webp";
import ThumbImg from "../../assets/images/conversations/046.webp";
import PlayIcon  from "../../assets/icons/conversations/play-icon.svg";

/* ─────────────────────────────────────────────
   PREFIX: as-
───────────────────────────────────────────── */
const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700;800&family=Roboto:wght@400;500&display=swap');

  *, *::before, *::after { margin: 0; padding: 0; box-sizing: border-box; }

  .as-page {
    background: #1A1A1A;
    min-height: 100vh;
    font-family: 'Roboto', sans-serif;
    color: #fff;
  }
  .as-inner {
    max-width: 1600px;
    margin: 0 auto;
    padding-left: 102px;
    padding-right: 102px;
  }

  /* ══════════════════════════════════════
     SECTION 1 — HERO
  ══════════════════════════════════════ */
  .as-hero { padding-top: 60px; padding-bottom: 60px; }
  .as-hero__grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 30px;
    align-items: start;
  }
  .as-hero__left { display: flex; flex-direction: column; gap: 44px; }
  .as-hero__title {
    font-family: 'Montserrat', sans-serif;
    font-size: 32px;
    font-weight: 700;
    color: #ffffff;
    line-height: 140%;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .as-hero__title.as-visible { opacity: 1; transform: translateY(0); }
  .as-hero__spotify {
    border-radius: 12px;
    overflow: hidden;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease 0.18s, transform 0.7s ease 0.18s;
  }
  .as-hero__spotify.as-visible { opacity: 1; transform: translateY(0); }
  .as-hero__spotify iframe {
    display: block; width: 100%; height: 152px; border: none; border-radius: 12px;
  }
  .as-hero__right {
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease 0.1s, transform 0.7s ease 0.1s;
  }
  .as-hero__right.as-visible { opacity: 1; transform: translateY(0); }

  /* thumbnail */
  .as-yt-thumb {
    position: relative; width: 100%; border-radius: 12px;
    overflow: hidden; cursor: pointer; display: block; background: #000;
  }
  .as-yt-thumb img {
    width: 100%; height: auto; display: block;
    border-radius: 12px; transition: opacity 0.3s ease;
  }
  .as-yt-thumb:hover img { opacity: 0.85; }
  .as-yt-thumb__play {
    position: absolute; top: 50%; left: 50%;
    transform: translate(-50%, -50%);
    background: none; border-radius: 50%;
    display: flex; align-items: center; justify-content: center;
    pointer-events: none;
  }
  .as-yt-thumb__play img { width: 40px; height: 44px; }
  .as-yt-iframe-wrap {
    position: relative; width: 100%; padding-bottom: 56.25%;
    height: 0; border-radius: 12px; overflow: hidden;
  }
  .as-yt-iframe-wrap iframe {
    position: absolute; top: 0; left: 0;
    width: 100%; height: 100%; border: none;
  }

  /* ══════════════════════════════════════
     SECTION 2 — BODY
  ══════════════════════════════════════ */
  .as-body {
    padding-bottom: 100px; opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .as-body.as-visible { opacity: 1; transform: translateY(0); }
  .as-body__para {
    font-family: 'Roboto', sans-serif; font-size: 16px;
    font-weight: 400; color: #E2E2E2; line-height: 160%; margin-bottom: 14px;
  }
  .as-body__para:last-child { margin-bottom: 0; }

  /* ══════════════════════════════════════
     SECTION 3 — OUR GUEST (1 guest)
  ══════════════════════════════════════ */
  .as-guest {
    padding-bottom: 100px; text-align: center; opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .as-guest.as-visible { opacity: 1; transform: translateY(0); }
  .as-guest__title {
    font-family: 'Montserrat', sans-serif; font-size: 50px;
    font-weight: 700; color: #ffffff; margin-bottom: 60px;
  }
  .as-guest__photo-bg {
    display: inline-block; width: 445px; height: 500px;
    background: #743FAC; border-radius: 12px; overflow: hidden;
  }
  .as-guest__photo-bg img {
    width: 100%; height: 100%; object-fit: cover;
    object-position: top center; display: block;
  }
  .as-guest__name {
    font-family: 'Montserrat', sans-serif; font-size: 32px;
    font-weight: 700; color: #ffffff; margin-top: 24px;
  }

  /* ── TABLET (max 768px) ── */
  @media (max-width: 768px) {
    .as-inner { padding-left: 32px; padding-right: 32px; }
    .as-hero { padding-top: 32px; padding-bottom: 48px; }
    .as-hero__grid { grid-template-columns: 1fr 1fr; gap: 24px; }
    .as-hero__title { font-size: 24px; }
    .as-hero__left { gap: 16px; }
    .as-guest__title { font-size: 24px; margin-bottom: 24px; }
    .as-guest__photo-bg { width: 260px; height: 300px; }
    .as-guest__name { font-size: 24px; margin-top: 18px; }
    .as-body__para { font-size: 14px; margin-bottom: 12px; }
    .as-body { padding-bottom: 48px; }
    .as-guest { padding-bottom: 48px; }
    .as-yt-thumb__play img { width: 30px; height: 32px; }
  }

  /* ── MOBILE (max 480px) ── */
  @media (max-width: 480px) {
    .as-inner { padding-left: 16px; padding-right: 16px; }
    .as-hero { padding-top: 51px; padding-bottom: 30px; }
    .as-hero__grid { grid-template-columns: 1fr; gap: 30px; }
    .as-hero__left { gap: 30px; }
    .as-hero__title { font-size: 30px; }
    .as-body__para { font-size: 16px; margin-bottom: 10px; }
    .as-guest__title { font-size: 30px; margin-bottom: 20px; }
    .as-guest__photo-bg { width: 100%; height: 386px; }
    .as-guest__name { font-size: 24px; text-align: left; margin-top: 14px; }
    .as-body { padding-bottom: 30px; }
    .as-guest { padding-bottom: 30px; }
    .as-yt-thumb__play img { width: 30px; height: 32px; }
  }
`;

function useFadeUp(ref) {
  useEffect(() => {
    if (!ref.current) return;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("as-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);
}

const YT_VIDEO_ID = "REPLACE_EP46_VIDEO_ID";

function YouTubeEmbed() {
  const [playing, setPlaying] = useState(false);
  if (playing) {
    return (
      <div className="as-yt-iframe-wrap">
        <iframe
          src={`https://www.youtube.com/embed/${YT_VIDEO_ID}?autoplay=1&rel=0`}
          title="EP 46 Akshay Singhal"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </div>
    );
  }
  return (
    <div className="as-yt-thumb" onClick={() => setPlaying(true)} role="button" aria-label="Play video">
      <img src={ThumbImg} alt="EP 46 Akshay Singhal thumbnail" />
      <div className="as-yt-thumb__play">
        <img src={PlayIcon} alt="Play" />
      </div>
    </div>
  );
}

function HeroSection() {
  const titleRef   = useRef(null);
  const spotifyRef = useRef(null);
  const rightRef   = useRef(null);
  useFadeUp(titleRef);
  useFadeUp(spotifyRef);
  useFadeUp(rightRef);

  return (
    <section className="as-hero">
      <div className="as-inner">
        <div className="as-hero__grid">
          <div className="as-hero__left">
            <h1 ref={titleRef} className="as-hero__title">
              EP 46 | Breaking down batteries with Log9 | Akshay Singhal
            </h1>
            <div ref={spotifyRef} className="as-hero__spotify">
              <iframe
                src="https://open.spotify.com/embed/episode/3jBTeJxPliW3CpzdviEzd8?utm_source=generator&theme=0"
                allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                loading="lazy"
                title="EP 46 Spotify Player"
              />
            </div>
          </div>
          <div ref={rightRef} className="as-hero__right">
            <YouTubeEmbed />
          </div>
        </div>
      </div>
    </section>
  );
}

function BodySection() {
  const ref = useRef(null);
  useFadeUp(ref);
  return (
    <section ref={ref} className="as-body">
      <div className="as-inner">
        <p className="as-body__para">
          Charge times, battery safety, and affordability are crucial – big obstacles that hinder the faster adoption of electric vehicles globally. In this episode, we engage with a remarkable company in India that is endeavoring to address these challenges in a unique way. Today, we speak with Dr. Akshay Singhal, Founder, and CEO of Log 9 Materials, who holds an honors degree in materials engineering from IIT Roorkee and is also a Forbes under 30 Asia honoree. Log 9 was founded in 2015, and in this time, it has amassed 35 industry-defining patents that attest to the organization's first-principle thinking. Log 9 Materials is able to offer batteries that can be charged nine times faster, last nine times longer, and offer nine times higher performance and safety. This is a fun one!
        </p>
      </div>
    </section>
  );
}

function GuestSection() {
  const ref = useRef(null);
  useFadeUp(ref);
  return (
    <section ref={ref} className="as-guest">
      <div className="as-inner">
        <h2 className="as-guest__title">Our Guest</h2>
        <div>
          <div className="as-guest__photo-bg">
            <img src={GuestImg} alt="Dr. Akshay Singhal" />
          </div>
          <p className="as-guest__name">Dr. Akshay Singhal</p>
        </div>
      </div>
    </section>
  );
}

export default function Ep46AkshaySinghal() {
  return (
    <>
      <style>{CSS}</style>
      <div className="as-page">
        <HeroSection />
        <BodySection />
        <GuestSection />
      </div>
    </>
  );
}